module.exports = {"230124100":"方正镇","230124101":"会发镇","230124102":"大罗密镇","230124103":"得莫利镇","230124200":"天门乡","230124201":"松南乡","230124202":"德善乡","230124204":"宝兴乡","230124400":"方正林业局","230124500":"沙河农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230124.json
// module id = 625
// module chunks = 0